import { Button } from '@edsn/pie-components';
import CsvIcon from '@iconify/icons-material-symbols/csv';
import { format } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Icon } from '#pie/components/icon/Icon';
import { useDebounce } from '#pie/hooks/useDebounce';
import { useExportCprContacts } from '#pie/internal/api/pie-bff';
import {
  cprContactFiltersAtom,
  cprContactSortingAtom,
} from '#pie/stores/cprContact';
import { paginationAtom } from '#pie/stores/pagination';
import { searchAtom } from '#pie/stores/search';
import { downloadBlob } from '#pie/utils/downloadBlob';

export const CprContactExport = () => {
  const { t } = useTranslation();
  const pagination = useAtomValue(paginationAtom);
  const filter = useAtomValue(cprContactFiltersAtom);
  const sorting = useAtomValue(cprContactSortingAtom);
  const search = useAtomValue(searchAtom);
  const debouncedSearch = useDebounce(search, 500);
  const sortCol = sorting[0];

  const { mutate, isPending: isDownloadingCsv } = useExportCprContacts({
    mutation: {
      onSuccess: (data: Blob) => {
        downloadBlob(
          data,
          `Contactpersoon_register_${format(new Date(), 'yyyy-MM-dd')}.csv`,
        );
      },
    },
  });

  return (
    <Button
      className="mr-4"
      iconStart={
        <Icon icon={CsvIcon} className="text-action-secondary-enabled" />
      }
      isLoading={isDownloadingCsv}
      action="tertiary"
      emphasis="subtle"
      onClick={() =>
        mutate({
          data: {
            filter,
            pagination,
            search: debouncedSearch,
            sorting: sortCol && { descending: sortCol.desc, field: sortCol.id },
          },
        })
      }
    >
      {t('cpr_contact_overview.header.button.export')}
    </Button>
  );
};
